import isUrl from 'is-url';

import { EXTERNAL_LINK_KIND } from '../constants/link';
import type { LinkProperties } from '../types';

interface GenerateFullUrlOptions {
  avoidConcatIfUrlIsAbsolute?: boolean;
}

interface GenerateLinkRelArgs {
  sponsored?: boolean;
  noFollow?: boolean;
}

export class LinkHelpers {
  static getLinkKindFromUrl(uri: string, linkProperties: LinkProperties) {
    return (
      linkProperties.dynamicLinkProperties.filter((p) => {
        return p.isCurrentKind(uri);
      })[0]?.title || EXTERNAL_LINK_KIND
    );
  }

  static formatUrlToExternalUrlOrInternalUrl(url: string) {
    if (url.startsWith('/')) return url;
    return `/${url}/`;
  }

  static generateFullUrl(urlPrefix: string, url: string, options?: GenerateFullUrlOptions) {
    if (isUrl(url)) return url;

    if (url?.startsWith('/')) {
      return `${urlPrefix}${url}`;
    }

    if (options?.avoidConcatIfUrlIsAbsolute) {
      return url;
    }

    return `${urlPrefix}/${url}`;
  }

  static generateLinkRel({ noFollow, sponsored }: GenerateLinkRelArgs) {
    const rels = [];
    if (noFollow) rels.push('nofollow');
    if (sponsored) rels.push('sponsored');

    if (rels.length === 0) return undefined;

    return rels.join(' ');
  }
}
